export const colors = {
    primaryBg: '#a7388e',
    primaryBgHover: '#c43ca8',
    mainBg: '#2e1c65',
    white: '#F8F8F8',
    bgWhite: '#f7f7f7',
    lightGrey: '#d6dce9',
    error: '#ff4d4f',
    blackText: '#1f1e24',
    gradStart: '#4d3c83',
    gradEnd: '#a35f9f',
    grey: '#333333',
    tableHeadBg: '#9481cd40',
    cleanWhite: '#ffffff',
    loader: '#E65E20',
    defChart: '#8884d8',
    iconHover: '#e59ad6',
};
